import Dialog from "@mui/material/Dialog";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import React from "react";
import useStore from "store/hook";
import { toast } from "react-toastify";
import Formatmessage from "services/Formatmessage";
import useLogout from "services/Handlelogout";
import deleteUniversity from "assets/images/university/deleteUniversity.png";
import { useDeleteuniversityMutation } from "store/api/universities.api";

const DeleteUniversity = () => {
  const { store, setDialogue } = useStore();
  const logout = useLogout();

  const  [deleteuniversity, { isLoading, error }] = useDeleteuniversityMutation();

  const {
    app: {
      dialogs: {
        deleteUniversity: { isOpen, action, schoolID },
      },
    },
  } = store;

  const handleClose = () => {
    setDialogue({
      type: "deleteUniversity",
      isOpen: false,
      action: "",
      schoolID: "",
    });
  };

  const handleDelete = async () => {
    try {
      const response = await deleteuniversity({ school_id: schoolID }).unwrap();

      if (response?.status == 1) {
        toast.success(Formatmessage(response?.message) || "School deleted successfully");
        handleClose();
      } else if (response?.status == 0) {
        toast.error(Formatmessage(response?.message));
      } else if (response?.status == 10) {
        logout();
      }

    } catch (error) {
      console.log("eror", error);
      toast.error("Server error. please try again in a few minutes.");
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "25px",
            m: {
              xs: 1,
              sm: 1,
              md: 2,
            },
          },
        }}
      >
        <SoftBox
          sx={{ boxSizing: "border-box", p: 0.5, backgroundColor: "secondary.main" }}
          borderRadius="xxl"
          width="100%"
        ></SoftBox>

        <SoftBox
          width="100%"
          display="flex"
          flexDirection="column"
          sx={{
            overflowY: "scroll",
            backgroundColor: "white.main",
            "&::-webkit-scrollbar": { display: "none" },
            msOverflowStyle: "none",
            scrollbarWidth: "none",
          }}
        >
          <SoftBox
            display="flex"
            width="100%"
            flexDirection="column"
            gap={2}
            sx={{ p: { xs: 1, sm: 2, md: 2 } }}
          >
            <SoftBox display="flex" alignItems="center" justifyContent="center">
              <SoftBox
                height="140px"
                width="140px"
                borderRadius="lg"
                sx={{
                  backgroundImage: `url(${deleteUniversity})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                }}
              />
            </SoftBox>

            <SoftBox display="flex" alignItems="center" justifyContent="center">
              <SoftTypography sx={{ fontSize: 18 }} color="black" fontWeight="medium">
                Delete School
              </SoftTypography>
            </SoftBox>

            <SoftBox display="flex" alignItems="center" justifyContent="center">
              <SoftTypography
                sx={{ fontSize: 16 }}
                align="center"
                color="lightblack"
                fontWeight="medium"
              >
                Are you sure you want to delete this school from the system? This action is
                permanent and cannot be undone.
              </SoftTypography>
            </SoftBox>

            <SoftBox
              width="100%"
              display="flex"
              gap={2}
              alignItems="center"
              justifyContent="space-between"
              sx={{
                flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <SoftButton
                onClick={handleClose}
                color="dark"
                sx={{ textTransform: "capitalize", fontSize: 16, width: "200px" }}
                variant="outlined"
              >
                Cancel
              </SoftButton>

              <SoftButton
                disabled={isLoading}
                onClick={handleDelete}
                color="primary"
                sx={{ textTransform: "capitalize", fontSize: 16, width: "200px" }}
                variant="contained"
              >
              { isLoading? "Loading..." : "Yes, Delete"}  
              </SoftButton>
            </SoftBox>
          </SoftBox>
        </SoftBox>

        <SoftBox
          sx={{ boxSizing: "border-box", p: 0.5, backgroundColor: "secondary.main", mt: "auto" }}
          borderRadius="xxl"
          width="100%"
        ></SoftBox>
      </Dialog>
    </React.Fragment>
  );
};

export default DeleteUniversity;
